import React from 'react';
import { Link } from 'react-router-dom';

const Developer = () => {
  return (
    <div className="w-full bg-white text-black py-4 px-6 md:px-12">
      <div className="max-w-screen-xl mx-auto flex flex-col md:flex-row justify-between items-center">
        {/* Left side: Copyright */}
        <div className="text-sm md:text-lg flex items-center space-x-2 mb-4 md:mb-0 text-center md:text-left">
          <p className="hover:underline transition-all duration-300">
            &copy; 2025 <span className="font-semibold">Shri Shanaishwar Foundation</span>
          </p>
        </div>

    
      </div>
    </div>
  );
};

export default Developer;
